import { createContext } from 'react';
import { noop } from '../../lib/utils';
import { DEFAULT_LOCATIONS } from '../constants';

export const DefaultGlobalContextValue = {
  analytics: {
    identifyUser: noop,
    tagEvent: noop,
    tagPageView: noop,
    isInitialized: false,
  },
  config: {
    atatusKey: '',
    criteo: '',
    consumerHost: 'www.gasbuddy.com',
    env: 'development',
    googleAppId: '',
    googleMapsKey: '',
    gtm: null,
    identityHost: 'iam.gasbuddy.com',
    imagesHost: 'images.gasbuddy.io',
    isMobile: false,
    localyticsKey: '',
    payHost: 'pay.gasbuddy.com',
    payNgHost: 'enroll.gasbuddy.com',
    publicPath: '/',
    recaptchaSiteKey: '',
    sywAppId: '',
    sywHost: 'shopyourway.com',
    trackerHost: 'tracker.gasbuddy.com',
  },
  geoIpInfo: {
    locality: DEFAULT_LOCATIONS.boston.city,
    state: DEFAULT_LOCATIONS.boston.region,
    zip: DEFAULT_LOCATIONS.boston.zip,
    country: DEFAULT_LOCATIONS.boston.country,
  },
  profile: {
    isLoggedIn: false,
    accountId: null,
    memberName: null,
    profileImageUrl: null,
    isPayUser: false,
    canSetMemberName: false,
  },
};

const GlobalContext = createContext(DefaultGlobalContextValue);

export default GlobalContext;
